import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import AdminHeader from "../header/admin_header";
import AdminSidebar from "../sidebar/admin_sidebar";
import { Question } from "../Company_Super_Admin/Questions Module/Question";
import { Questions } from "../Company_Super_Admin/Questions Module/Questions";
import { Sectors } from "./Sectors";
import { SectorQuestion } from "./SectorQuestion";
const SectorModule = (props) => {
  const [data, setData] = useState(props.data);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("framework");

  const [activeModule, setActiveModule] = useState(false);
  const [currentTopicData, setCurrentTopicData] = useState({});


  const handleTopicChangeHandler = (data, tabId) => {
    setActiveTab(tabId);
    setCurrentTopicData(data);
  };

  const handleAddFrameworkQuestionChangeHandler = (data) => {
  };



  const handleAddTopicQuestionChangeHandler = (data, framworkData) => {
    framworkData["topic_id"] = data.id;
  };


  const handleKPIChangeHandler = (
    data,
    finalYearData,
    frameworkData,
    tabId
  ) => {
    frameworkData["topic_id"] = data.id;
    setActiveTab(tabId);
    setData(finalYearData);
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleFrameworkTabClose = (event, tabId) => {
    event.stopPropagation();
    if (activeTab === tabId) {
      setActiveTab("financial");
      setActiveModule(false);

    }
  };



  return (
    <div>
      <AdminSidebar dataFromParent={location.pathname} />
      <AdminHeader />
      <div className="main_wrapper">
        <div className="inner_wraapper">
          <div className="color_div_on framwork_2">
            <div className="tab-container">
              <div className="tab-menu border-bottom mb-2 d-flex align-items-center justify-content-between">
                <ul>
                  {/* --------------- Financial Year Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        activeTab === "framework" ? "active-a" : ""
                      }`}
                      onClick={() => handleTabClick("framework")}
                      data-id="framework"
                    >
                        Emission Modules
                    </div>
                  </li>

                  {/* --------------- Framework Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        activeTab === "topic"
                          ? "active-a"
                          : "" ||
                            (activeModule === true ? "d-block" : "d-none")
                      }`}
                      onClick={() => handleTabClick("topic")}
                      data-id="topic"
                    >
                      Questions
                      <span
                        className="close_tab_cell"
                        title="Close Framework"
                        onClick={(e) => handleFrameworkTabClose(e, "topic")}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  </li>

                </ul>
                <div>
                  <p>
                    <strong>
                      {data && data?.country_name} &nbsp;&nbsp;
                      {data && data?.financial_year_value}
                    </strong>
                  </p>
                </div>
              </div>
              {/* --------------- Financial Year Tab ----------------------- */}
              <div
                className="tab"
                data-id="framework"
                style={{
                  display: activeTab === "framework" ? "block" : "none",
                }}
              >
                <Sectors 
                  handleTopicChangeHandler={handleTopicChangeHandler}
                  handleAddFrameworkQuestionChangeHandler={
                    handleAddFrameworkQuestionChangeHandler
                  }
                />
              </div>
              {/* --------------- Framework Tab ----------------------- */}
              <div
                className="tab"
                data-id="topic"
                style={{
                  display: activeTab === "topic" ? "block" : "none",
                }}
              >
                <SectorQuestion
                sectorData={currentTopicData}  
                handleKPIChangeHandler={handleKPIChangeHandler}
                handleAddTopicQuestionChangeHandler={
                  handleAddTopicQuestionChangeHandler
                  }
                />
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectorModule;